export default {
  editorPopup: false,
  talentReportPopup: false,
  isUniversalLoading:false
};
